import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58f2bb86")

_pushScopeId("data-v-58f2bb86")
const _hoisted_1 = { class: "projectSettings" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("项目设置")
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("项目修改")
], -1)
const _hoisted_5 = { class: "all_option" }
const _hoisted_6 = { class: "itemIcon" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "项目图标", -1)
const _hoisted_8 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "项目id", -1)
const _hoisted_10 = { class: "entryName" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "项目名称", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "Android包名", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "iOS包名", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "操作", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_26 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("注册设备")
], -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("注册")
const _hoisted_29 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("复制数据")
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px","line-height":"45px"} }, " 1、复制之前会检查是否已经复制，不会复制重复对象 "),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px","line-height":"45px"} }, " 2、各模块可以独立复制， "),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"14px","line-height":"45px"} }, " 3、如果复制的模块有关联表, 会复制一份关联数据, 比如任务配置有设备、场景、账号等，复制任务时会复制一份配置的设备、场景、账号。 ")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "复制", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_breadcrumb, {
                  "separator-class": "el-icon-arrow-right",
                  class: "PosTitle"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_breadcrumb_item, null, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_breadcrumb_item, null, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider),
                _withDirectives(_createVNode(_component_el_card, null, {
                  default: _withId(() => [
                    _hoisted_4,
                    _createVNode("div", _hoisted_5, [
                      _withDirectives(_createVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          "http-request": _ctx.ploadImage,
                          action: "http://127.0.0.1:8081/api/v1/proj/project_icon/",
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "on-change": _ctx.imgPreview,
                          disabled: _ctx.edit
                        }, {
                          default: _withId(() => [
                            (_ctx.getImage)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: _ctx.getImage,
                                  class: "avatar"
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock("i", _hoisted_8))
                          ]),
                          _: 1
                        }, 8, ["http-request", "on-success", "on-change", "disabled"])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_9,
                        _createVNode("p", null, _toDisplayString(_ctx.myProjects.id), 1)
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _hoisted_11,
                        (!_ctx.edit)
                          ? (_openBlock(), _createBlock("p", _hoisted_12, [
                              _createVNode(_component_el_input, {
                                size: "mini",
                                placeholder: "请输入项目名称",
                                modelValue: _ctx.myProjects.project_name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.myProjects.project_name = $event)),
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.myProjects.project_name), 1))
                      ]),
                      _createVNode("div", null, [
                        _hoisted_14,
                        (!_ctx.edit)
                          ? (_openBlock(), _createBlock("p", _hoisted_15, [
                              _createVNode(_component_el_input, {
                                size: "mini",
                                placeholder: "请输入游戏包名",
                                modelValue: _ctx.myProjects.pkg_name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.myProjects.pkg_name = $event)),
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_16, _toDisplayString(_ctx.myProjects.pkg_name), 1))
                      ]),
                      _createVNode("div", null, [
                        _hoisted_17,
                        (!_ctx.edit)
                          ? (_openBlock(), _createBlock("p", _hoisted_18, [
                              _createVNode(_component_el_input, {
                                size: "mini",
                                placeholder: "请输入游戏包名",
                                modelValue: _ctx.myProjects.ios_pkg_name,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.myProjects.ios_pkg_name = $event)),
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.myProjects.ios_pkg_name), 1))
                      ]),
                      _createVNode("div", null, [
                        _hoisted_20,
                        (_ctx.edit)
                          ? (_openBlock(), _createBlock("p", _hoisted_21, [
                              _createVNode(_component_el_button, {
                                type: "warning",
                                size: "mini",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editOption('edit'))),
                                disabled: _ctx.get_is_super
                              }, {
                                default: _withId(() => [
                                  _hoisted_22
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_23, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editOption('ok')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "info",
                                size: "mini",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editOption('no')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_25
                                ]),
                                _: 1
                              })
                            ]))
                      ])
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_directive_loading, _ctx.loading]
                ]),
                false
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                      default: _withId(() => [
                        _hoisted_26,
                        _createVNode(_component_el_form, {
                          class: "RegisterForm",
                          model: _ctx.registerForm,
                          "label-position": "top",
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_row, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "model" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.model,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.registerForm.model = $event)),
                                      placeholder: "model"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "type",
                                  style: {"width":"165px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.registerForm.type,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.registerForm.type = $event)),
                                      placeholder: "type"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_option, {
                                          label: "Android",
                                          value: "0"
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "iOS",
                                          value: "1"
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "PC",
                                          value: "2"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "rank" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.rank,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.registerForm.rank = $event)),
                                      placeholder: "rank"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "score" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.score,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.registerForm.score = $event)),
                                      placeholder: "score"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "user_rank" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.user_rank,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.registerForm.user_rank = $event)),
                                      placeholder: "user_rank"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "user_percentage" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.user_percentage,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.registerForm.user_percentage = $event)),
                                      placeholder: "user_percentage"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "name" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.name,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.registerForm.name = $event)),
                                      placeholder: "name"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "oem" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.oem,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.registerForm.oem = $event)),
                                      placeholder: "oem"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "cpu_name" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.cpu_name,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.registerForm.cpu_name = $event)),
                                      placeholder: "cpu_name"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "cpu_model" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.cpu_model,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.registerForm.cpu_model = $event)),
                                      placeholder: "cpu_model"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "core_num" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.core_num,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.registerForm.core_num = $event)),
                                      placeholder: "core_num"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "ram" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.ram,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.registerForm.ram = $event)),
                                      placeholder: "ram"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "gpu_name" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.gpu_name,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.registerForm.gpu_name = $event)),
                                      placeholder: "gpu_name"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "resolution" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.registerForm.resolution,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.registerForm.resolution = $event)),
                                      placeholder: "resolution"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, { onClick: _ctx.ResetBtn }, {
                                      default: _withId(() => [
                                        _hoisted_27
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _ctx.RegisterForm
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_28
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_loading, _ctx.loading]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_el_card, null, {
                  default: _withId(() => [
                    _hoisted_29,
                    _hoisted_30,
                    _createVNode(_component_el_form, {
                      class: "RegisterForm",
                      model: _ctx.copyForm,
                      "label-position": "top",
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_row),
                        _createVNode(_component_el_row, null, {
                          default: _withId(() => [
                            _createVNode("div", null, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.copyForm.project,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.copyForm.project = $event)),
                                placeholder: "复制项目",
                                size: "small"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projects, (i) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: i.id,
                                      label: i.name,
                                      value: i.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.all,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.copyForm.all = $event)),
                                label: "全部",
                                border: "",
                                size: "small",
                                onChange: _ctx.all
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.account,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.copyForm.account = $event)),
                                label: "账号",
                                border: "",
                                size: "small",
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.cacel_all('account')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.device,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.copyForm.device = $event)),
                                label: "设备",
                                border: "",
                                size: "small",
                                onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.cacel_all('device')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.scene,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.copyForm.scene = $event)),
                                label: "场景脚本",
                                border: "",
                                size: "small",
                                onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.cacel_all('scene')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.pipeline,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.copyForm.pipeline = $event)),
                                label: "流水线",
                                border: "",
                                size: "small",
                                onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cacel_all('pipeline')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.project_user,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.copyForm.project_user = $event)),
                                label: "权限",
                                border: "",
                                size: "small",
                                onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.cacel_all('project_user')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.task,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.copyForm.task = $event)),
                                label: "测试任务",
                                border: "",
                                size: "small",
                                onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.cacel_all('task')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.performance_brief,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.copyForm.performance_brief = $event)),
                                label: "测试数据",
                                border: "",
                                size: "small",
                                onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.cacel_all('performance_brief')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.copyForm.report,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.copyForm.report = $event)),
                                label: "报告",
                                border: "",
                                size: "small",
                                onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.cacel_all('report')))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_popconfirm, {
                                  onConfirm: _ctx.copyFunc,
                                  title: "确认复制项目数据？"
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      size: "mini",
                                      disabled: _ctx.get_is_super || _ctx.copyForm.project === ''
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_tooltip, {
                                          content: "暂无管理员权限",
                                          placement: "top",
                                          disabled: !_ctx.get_is_super
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_31
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["onConfirm"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }, 512), [
                  [_directive_loading, _ctx.loading]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})